  $(document).on('ready', function() {
    $(".blog-slider2").slick({
      dots: false,
      arrows: true,
      vertical: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      centerMode:false,
      responsive: [
        {

          breakpoint: 1090,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            centerPadding: '70px',
            slidesToScroll: 1,
            arrows: false
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '70px',
            centerMode: false,
            arrows: false
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    });
  });